import {
  ParenthesisLeftIcon,
  ParenthesisRightIcon,
} from "@/components/icons/ParenthesisIcons";
import { LuUserRound } from "react-icons/lu";
import { MdOutlineMedicalInformation } from "react-icons/md";

/**
 * 窓口支払額・自己負担額の表示
 * size="md": PlanRow・OptionRow単一価格用（大きめ）
 * size="sm": OptionRowコース別価格用（小さめ）
 */
export const PriceDisplay = ({
  counterPayAmount,
  selfPayAmount,
  size = "md",
}: {
  counterPayAmount: number;
  selfPayAmount: number;
  size?: "md" | "sm";
}) => {
  const iconSize = size === "md" ? "h-4 w-4" : "h-3 w-3";
  const amountSize =
    size === "md"
      ? "text-xl font-bold text-primary-6 tabular-nums"
      : "text-base font-bold text-primary-6 tabular-nums";
  const unitSize = size === "md" ? "text-base" : "text-sm";
  const parenthesisWidth = size === "md" ? "w-3" : "w-2.5";
  const innerPadding = size === "md" ? "px-1" : "px-0.5";

  return (
    <div className="flex items-center gap-4">
      <div className="text-right">
        <div className="flex items-center gap-1 text-xs">
          <MdOutlineMedicalInformation className={iconSize} />
          <span>窓口支払額</span>
        </div>
        <div className={amountSize}>
          {counterPayAmount.toLocaleString()}
          <span className={unitSize}> 円</span>
        </div>
      </div>
      <div className="flex items-stretch">
        <ParenthesisLeftIcon className={parenthesisWidth} />
        <div className={`${innerPadding} text-right`}>
          <div className="flex items-center gap-1 text-xs">
            <LuUserRound className={iconSize} />
            <span>自己負担額</span>
          </div>
          <div className={amountSize}>
            {selfPayAmount.toLocaleString()}
            <span className={unitSize}> 円</span>
          </div>
        </div>
        <ParenthesisRightIcon className={parenthesisWidth} />
      </div>
    </div>
  );
};
